import Footer from "modules/Footer";
import Header from "modules/Header";
import { Outlet } from "react-router";
import { useSelector } from "react-redux";

import styles from "./styles.module.scss";

const Layout = ({ children, transparentHeader = false }) => {
  return (
    <div className={styles.layoutWrapper}>
      <Header transparent={transparentHeader} />
      <div className={styles.content}>{children ? children : <Outlet />}</div>
      <Footer />
    </div>
  );
};

export default Layout;
